<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Contactgegevens belastingconsulent
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Als de Belastingdienst vragen/opmerkingen heeft over de aangifte, dan kan er contact worden opgenomen met de belastingconsulent.
                <br/>
                <br/>
                Vul de gegevens in. Het beconnummer is het registratienummer dat je bij de Belastingdienst kunt aanvragen.
            </div>
        </div>
    </div>
</div>
